function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameAcknowledgeOverlayTemplate = require('./game-acknowledge-overlay.template');
var SaitoOverlay = require('./../saito-overlay/saito-overlay');
var GameAcknowledgeOverlay = /*#__PURE__*/function () {
  function GameAcknowledgeOverlay(app, mod) {
    _classCallCheck(this, GameAcknowledgeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
  }
  return _createClass(GameAcknowledgeOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = 0;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.visible = 1;
      this.overlay.show(GameAcknowledgeOverlayTemplate(msg));
      try {
        document.querySelector('.game-acknowledge-overlay').style.backgroundImage = "url(".concat(img, ");");
        document.querySelector('.game-acknowledge-menu').innerHTML = "<div class=\"game-acknowledge-notice\">".concat(msg, "</div><ul><li class=\"textchoice acknowledge\" id=\"acknowledge\">acknowledge</li></ul>");
      } catch (err) {}
    }
  }]);
}();
module.exports = GameAcknowledgeOverlay;